import httpAction from './httpAction';

const httpActionTemplate = {
  endpoint: null,
  verb: 'GET',
  payload: null,
  headers: [],
  params: {},
};

const httpMiddleware = () => (next) => (action) => {
  if (action.type === httpAction.type) {
    const { payload: actionProps } = action;
    const beganActionType = `${actionProps.reducer}Began`;
    const successActionType = `${actionProps.reducer}Success`;
    const errorActionType = `${actionProps.reducer}Error`;

    next({ type: beganActionType, payload: true });

    const fetchOptions = { ...httpActionTemplate, ...actionProps };
    const { httpClient } = actionProps;
    let fetchMethod;
    switch (fetchOptions.verb) {
      case 'GET':
        fetchMethod = () =>
          httpClient.get(fetchOptions.endpoint, fetchOptions.params);
        break;
      case 'POST':
        fetchMethod = () =>
          httpClient.post(
            fetchOptions.endpoint,
            fetchOptions.body,
            fetchOptions.params
          );
        break;
      case 'PUT':
        fetchMethod = () =>
          httpClient.put(
            fetchOptions.endpoint,
            fetchOptions.body,
            fetchOptions.params
          );
        break;
      case 'DELETE':
        fetchMethod = () => httpClient.delete(fetchOptions.endpoint);
        break;
      default:
        break;
    }

    if (fetchMethod) {
      (async () => {
        try {
          const res = await fetchMethod();
          next({ type: successActionType, payload: res.data });
        } catch (err) {
          next({ type: errorActionType, payload: err.message });
        }
      })();
    } else {
      next({ type: beganActionType, payload: false });
      throw new Error('Invalid fetch method provided');
    }
  } else next(action);
};

export default httpMiddleware;
